<h3 class="text-align--center">{{message()}}</h3>
<dot-loader [large]="true" [visibility]="true"></dot-loader>
@if(progress() !== null && progress() !== undefined) {
    <woo-progress-bar [progress]="progress()"></woo-progress-bar>
}
@if(progress_message()) {
    <h3 class="text-align--center">{{progress_message()}}</h3>
}